import gql from 'graphql-tag';

export const getDatabasesAppListGql = gql`
   query getSucursal($app: String!) {
      databasesAppList(app: $app)
   }
`;

export const getCuentasMaxLimitesGql = gql`
   query getCuentasMaxLimites {
      cuentasMaxlimites {
         cuenta
         nombre
         apPaterno
         apMaterno
         email
         fechaExpiracion
      }
   }
`;

export const getNanagerInstanciasGql = gql`
   query getNanagerInstancias($app: String!) {
      managerInstancias(app: $app) {
         idInstancia
         denominacion
         cuentasManager {
            idCuenta
            idInstanciaCuenta
         }
         escritoriosManager {
            idEscritorio
            idItem
            estado
            enPapelera
         }
      }
   }
`;

export const deleteDbInstancesGql = gql`
   mutation DeleteDatabasesApp($app: String!, $databasesInfo: [DatabasesToDeleteInfo]!) {
      deleteDatabasesApp(app: $app, databasesInfo: $databasesInfo) {
         idDatabase
         idInstancia
         resultados {
            origen
            estado
            mensaje
         }
      }
   }
`;
